<div class="task-sidenav-task-fields">
  <div class="task-sidenav-task-fields__field">
    <div class="new-select-label">{{ 'MyWork.Card.priorityLabel' | translate }}</div>
    <button
      type="button"
      class="task-sidenav-task-fields__priority"
      [class.task-sidenav-task-fields__priority--sofort]="currentTaskPriority === 1"
      [class.task-sidenav-task-fields__priority--dringend]="currentTaskPriority === 2"
      [disabled]="service.task?.isDeleted || service.loading || prioritySaving"
      [matMenuTriggerFor]="taskPriorityMenu"
      [attr.aria-label]="'MyWork.Card.priorityLabel' | translate"
    >
      @if (currentTaskPriority !== 4) {
        <span class="task-sidenav-task-fields__priority-value">
          <span class="task-sidenav-task-fields__priority-dot"></span>
          <span>{{ 'MyWork.Card.priority.' + priorityLabel(currentTaskPriority) | translate }}</span>
        </span>
      }
      <mat-icon>expand_more</mat-icon>
    </button>
    <mat-menu #taskPriorityMenu="matMenu" class="menu-v2 task-sidenav-priority-menu">
      <button
        *ngFor="let priority of taskPriorities"
        mat-menu-item
        type="button"
        class="task-sidenav-priority-option"
        (click)="onTaskPrioritySelected(priority)"
      >
        <span
          class="task-sidenav-priority-option__content"
          [class.task-sidenav-priority-option__content--sofort]="priority === 1"
          [class.task-sidenav-priority-option__content--dringend]="priority === 2"
          [class.task-sidenav-priority-option__content--none]="priority === 4"
        >
          <span class="task-sidenav-priority-option__dot" aria-hidden="true"></span>
          <span>{{ 'MyWork.Card.priority.' + priorityLabel(priority) | translate }}</span>
        </span>
      </button>
    </mat-menu>
  </div>

  <div class="task-sidenav-task-fields__field">
    <label class="new-select-label" for="task-sidenav-estimated-time">
      {{ 'MyWork.Columns.minutes' | translate }}
    </label>
    <div class="task-sidenav-task-fields__minutes">
      <input
        id="task-sidenav-estimated-time"
        type="number"
        min="0"
        max="525600"
        step="1"
        [value]="service.form.get(service.TASK_SIDENAV_FORM.estimatedTime)?.value ?? ''"
        [disabled]="service.task?.isDeleted || service.loading || minutesSaving"
        [attr.aria-label]="'MyWork.Columns.minutes' | translate"
        (blur)="onEstimatedTimeBlur($event)"
        (keydown)="onEstimatedTimeKeydown($event)"
      />
      <span aria-hidden="true">min</span>
    </div>
  </div>

  <div class="task-sidenav-task-fields__field">
    <div class="new-select-label">{{ 'MyWork.Columns.deadline' | translate }}</div>
    <div class="task-sidenav-task-fields__deadline-container">
      <button
        type="button"
        class="task-sidenav-task-fields__deadline"
        [class.task-sidenav-task-fields__deadline--today]="deadlineTone === 'today'"
        [class.task-sidenav-task-fields__deadline--past]="deadlineTone === 'past'"
        [disabled]="service.task?.isDeleted || service.loading || deadlineSaving"
        [matTooltip]="deadlineTooltip"
        [attr.aria-label]="'realizationTerm' | translate"
        (click)="openRangePicker(); taskRangePicker.open()"
      >
        <svg-icon src="./assets/img/calendar-v2-icon.svg" [svgStyle]="{ width: '18px', height: '18px' }" />
        <span>{{ deadlineLabel }}</span>
      </button>
      <mat-date-range-input [rangePicker]="taskRangePicker" class="task-sidenav-task-fields__range-input">
        <input matStartDate [formControl]="rangeStart" />
        <input matEndDate [formControl]="rangeEnd" (dateChange)="onRangeEndChanged($event)" />
      </mat-date-range-input>
      <mat-date-range-picker #taskRangePicker />
      @if (service.form.get(service.TASK_SIDENAV_FORM.termEnd)?.value) {
        <button
          type="button"
          class="task-sidenav-task-fields__clear"
          [disabled]="service.task?.isDeleted || service.loading || deadlineSaving"
          [attr.aria-label]="'MyWork.Card.clearDeadline' | translate"
          (click)="clearRange($event)"
        >×</button>
      }
    </div>
  </div>
</div>
